import { useQuery } from '@tanstack/react-query';

import { fetchUserRecentSearchRecords } from '@/api/v4/search.api';
import { QueryKey } from '@/config/query-client';
import { useCurrentUser } from '@/user/use-current-user.query';

export const useRecentSearchRecords = () => {
  const { data: user } = useCurrentUser();

  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKey.UserRecentSearchRecords, user?.id],
    queryFn: async () => await fetchUserRecentSearchRecords(),
    enabled: !!user?.id,
    staleTime: 1000 * 60 * 60 * 24 * 60,
    gcTime: 1000 * 60 * 60 * 24 * 60,
  });
  const hasUserSomeRecentSearchRecords = !isLoading && !!data?.length;

  return {
    data,
    isLoading,
    hasUserSomeRecentSearchRecords,
    error,
  };
};
